import keys from 'lodash/keys';
import CustomersAllIcon from './icons/customers-all.svg';
import CustomersRegularIcon from './icons/customers-regular.svg';
import CustomersLapsingIcon from './icons/customers-lapsing.svg';
import CustomersProspectiveIcon from './icons/customers-prospective.svg';
export var customerGroupsViewConfig = {
    all: {
        displayGroupName: 'All clients',
        IconComponent: CustomersAllIcon,
    },
    regular: {
        displayGroupName: 'Regular clients',
        IconComponent: CustomersRegularIcon,
    },
    lapsing: {
        displayGroupName: 'Lapsed clients',
        IconComponent: CustomersLapsingIcon,
    },
    prospective: {
        displayGroupName: 'Prospective clients',
        IconComponent: CustomersProspectiveIcon,
    },
};
export var GROUPS_TO_SHOW = keys(customerGroupsViewConfig);
